/* Custom sort: Ofertas primero - v5 (stable) */
(function(){
if(window.CristinitaSort)return;
window.CristinitaSort={
  sorting:false,
  obs:null,
  isSaleSort:function(){return location.search.indexOf('sort_by=best-selling')>-1},

  fixImages:function(card){
    card.querySelectorAll('img[data-src]').forEach(function(img){
      if(!img.src||img.src===''||img.src===location.origin+'/'){
        var ds=img.getAttribute('data-src');
        if(ds)img.src=ds.replace('{width}','540');
      }
    });
  },

  pauseObserver:function(){
    if(this.obs){this.obs.disconnect()}
  },

  resumeObserver:function(grid){
    var self=this;
    if(!this.obs)return;
    setTimeout(function(){
      self.obs.observe(grid,{childList:true});
    },500);
  },

  sortSaleFirst:function(){
    if(this.sorting)return;
    this.sorting=true;
    var self=this;
    var block=document.querySelector('.product-block');
    if(!block){self.sorting=false;return}
    var grid=block.parentElement;
    var m=location.pathname.match(/\/collections\/([^\/\?]+)/);
    if(!m){self.reorderCurrent(grid);return}
    var handle=m[1];

    self.pauseObserver();

    var currentCards=Array.from(grid.querySelectorAll(':scope > .product-block'));
    var currentSale=[];var currentReg=[];
    currentCards.forEach(function(c){
      c.querySelector('.product-label--on-sale')?currentSale.push(c):currentReg.push(c);
    });
    var extraSale=[];
    var page=2;
    function fetchNext(){
      if(page>6){finish();return}
      fetch('/collections/'+handle+'?page='+page,{cache:'no-store'})
        .then(function(r){return r.text()})
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var cards=doc.querySelectorAll('.product-block');
          if(cards.length===0){finish();return}
          cards.forEach(function(c){
            if(c.querySelector('.product-label--on-sale')){
              var adopted=document.adoptNode(c);
              self.fixImages(adopted);
              extraSale.push(adopted);
            }
          });
          page++;
          fetchNext();
        }).catch(function(){finish()});
    }
    function finish(){
      var allSale=currentSale.concat(extraSale);
      var seen={};var uniqueSale=[];
      allSale.forEach(function(c){
        var a=c.querySelector('a[href*="/products/"]');
        var href=a?a.getAttribute('href'):'x'+Math.random();
        if(!seen[href]){seen[href]=true;uniqueSale.push(c)}
      });
      while(grid.firstChild)grid.removeChild(grid.firstChild);
      uniqueSale.forEach(function(c){grid.appendChild(c)});
      currentReg.forEach(function(c){grid.appendChild(c)});
      if(window.Wishlist&&Wishlist.initCards)setTimeout(function(){Wishlist.initCards()},200);
      self.sorting=false;
      /* Do NOT resume observer - sort is done */
    }
    fetchNext();
  },

  reorderCurrent:function(grid){
    this.pauseObserver();
    var cards=Array.from(grid.querySelectorAll(':scope > .product-block'));
    var s=[],r=[];
    cards.forEach(function(c){c.querySelector('.product-label--on-sale')?s.push(c):r.push(c)});
    s.concat(r).forEach(function(c){grid.appendChild(c)});
    this.sorting=false;
  },

  init:function(){
    var self=this;
    if(self.isSaleSort()){
      setTimeout(function(){self.sortSaleFirst()},800);
    }else{
      /* Only observe if NOT already in sale sort (to catch AJAX sort change) */
      var block=document.querySelector('.product-block');
      if(block){
        var grid=block.parentElement;
        self.obs=new MutationObserver(function(){
          if(!self.sorting&&self.isSaleSort()){
            self.obs.disconnect();
            setTimeout(function(){self.sortSaleFirst()},400);
          }
        });
        self.obs.observe(grid,{childList:true});
      }
    }
  }
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){CristinitaSort.init()});
else CristinitaSort.init();
})();